import { useGetMainPageUrl } from 'app-level/navigation';
import { MainRouteKeys } from 'app-level/navigation/navigation.config';
import { NavLink } from 'react-router-dom';

import { HeaderMenuItemConfig } from '../Header/headers.config';
import { MainNavIcon } from '../Header/MainNavIcon';

interface PassedProps {
  tabDetails: HeaderMenuItemConfig<MainRouteKeys>;
  isTourAnchor?: boolean;
}

const HeaderMenuItem = ({ tabDetails, isTourAnchor = true }: PassedProps) => {
  const getPath = useGetMainPageUrl();
  const { routeKey = 'home' } = tabDetails;

  // If routeKey is a valid main route key, use `getPath`
  const isMainRoute = ['home', 'portfolio', 'sales', 'market-data', 'account'].includes(routeKey);

  const resolvedPath = isMainRoute ? getPath(routeKey as MainRouteKeys) : `/${routeKey}`;

  return (
    <div>
      <li className="flex list-none items-center">
        <NavLink
          to={resolvedPath}
          data-tour={routeKey === 'home' && isTourAnchor ? 'home-nav' : undefined}
          aria-label={tabDetails.label}
          title={tabDetails.label}
          className={({ isActive }) =>
            [
              'mx-1 border-b-2 border-transparent-0 px-3 pb-0 pt-6 lg:mx-2 lg:px-4',
              'flex items-center whitespace-nowrap text-base text-foreground-default no-underline',
              isActive
                ? 'border-foreground-default opacity-100 light:border-black light:text-black'
                : 'border-transparent opacity-50 hover:opacity-100 light:text-gray-600 light:opacity-100 light:hover:text-black',
            ].join(' ')
          }
        >
          {tabDetails.iconName && <MainNavIcon name={tabDetails.iconName} size="extraLarge" />}
          <span className="hidden pl-2 lg:inline">{tabDetails.label}</span>
        </NavLink>
      </li>
    </div>
  );
};

export default HeaderMenuItem;
